export default __webpack_public_path__ + "static/media/home-slider-2-comp.876d9ee5.png";